import { formatReportDateUnix } from "@entities/history";
import { ReportPassportProps } from "./types";
import classes from "./report-passport.module.scss";

export const ReportPassport = ({
    brand,
    model,
    year,
    color,
    engineVolume,
    horsePower,
    engineNumber,
    vin,
    ptsType,
    ptsData
}: ReportPassportProps) => {
    return (
        <div className={classes.passport}>
            <div className={classes.passport__row}>
                <div className={classes.passport__label}>Марка и модель</div>
                <div className={classes.passport__value}>
                    {brand} {model}
                </div>
            </div>
            <div className={classes.passport__row}>
                <div className={classes.passport__label}>Год выпуска</div>
                <div className={classes.passport__value}>{year} г.</div>
            </div>
            <div className={classes.passport__row}>
                <div className={classes.passport__label}>Цвет</div>
                <div className={classes.passport__value}>{color}</div>
            </div>
            <div className={classes.passport__row}>
                <div className={classes.passport__label}>Объём двигателя</div>
                <div className={classes.passport__value}>{engineVolume} см³</div>
            </div>
            <div className={classes.passport__row}>
                <div className={classes.passport__label}>Мощность двигателя</div>
                <div className={classes.passport__value}>{horsePower} л.с.</div>
            </div>
            <div className={classes.passport__row}>
                <div className={classes.passport__label}>Номер двигателя</div>
                <div className={classes.passport__value}>{engineNumber}</div>
            </div>
            <div className={classes.passport__row}>
                <div className={classes.passport__label}>VIN</div>
                <div className={classes.passport__value}>{vin}</div>
            </div>
            {ptsType && (
                <div className={classes.passport__row}>
                    <div className={classes.passport__label}>Тип ПТС</div>
                    <div className={classes.passport__value}>{ptsType}</div>
                </div>
            )}
            {ptsData?.pts?.createdAt && (
                <div className={classes.passport__row}>
                    <div className={classes.passport__label}>Дата выдачи ПТС</div>
                    <div className={classes.passport__value}>
                        {formatReportDateUnix(ptsData.pts.createdAt)}
                    </div>
                </div>
            )}
        </div>
    );
};